import React from 'react';
import type { TextAreaProps } from '@atlaskit/textarea';
import type { RenderFn } from '@atlassian/forge-ui';
import type { Handler } from '@atlassian/forge-ui-types';

const AKTextArea = React.lazy(
	() =>
		import(
			/* webpackChunkName: "atlaskit-textarea" */
			'@atlaskit/textarea'
		),
);

interface ForgeDocProps {
	name?: string;
	isMonospaced?: boolean;
	placeholder?: string;
	spellCheck?: boolean;
	onBlur?: Handler;
	value?: string;
	appearance?: TextAreaProps['appearance'];
	resize?: TextAreaProps['resize'];
	minimumRows?: number;
}

export function useTextArea({ forgeDoc, dispatch }: Parameters<RenderFn>[0]): {
	akTextAreaProps: TextAreaProps;
} {
	const {
		props: {
			name,
			isMonospaced,
			placeholder,
			spellCheck,
			onBlur,
			value,
			appearance = 'standard',
			resize = 'smart',
			minimumRows = 2,
		} = {} as ForgeDocProps,
	} = forgeDoc as { props?: ForgeDocProps };

	const handleBlur = async (textValue: string) => {
		if (onBlur) {
			await dispatch({
				type: 'event',
				handler: onBlur,
				args: [textValue],
				extensionData: {},
			});
		}
	};

	return {
		akTextAreaProps: {
			name,
			appearance,
			resize,
			minimumRows,
			isMonospaced,
			placeholder,
			spellCheck,
			value,
			// @typescript-eslint upgrade to v5.61.0
			// eslint-disable-next-line @typescript-eslint/no-misused-promises
			onBlur: (event) => handleBlur(event.target.value),
		},
	};
}

export function PortalTextArea(props: Parameters<RenderFn>[0]) {
	const { akTextAreaProps } = useTextArea(props);
	return <AKTextArea {...akTextAreaProps} />;
}
